import { useState } from "react";
import { photoSrc } from "@/lib/api";

const STATUS_STYLES = {
  Available: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Interviewing: "bg-amber-50 text-amber-700 border-amber-200",
  Placed: "bg-stone-100 text-stone-600 border-stone-200",
  Pending: "bg-amber-50 text-amber-700 border-amber-200",
  "In Review": "bg-blue-50 text-blue-700 border-blue-200",
  Approved: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Declined: "bg-red-50 text-red-700 border-red-200",
  Requested: "bg-amber-50 text-amber-700 border-amber-200",
  Scheduled: "bg-blue-50 text-blue-700 border-blue-200",
  Completed: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Cancelled: "bg-red-50 text-red-700 border-red-200",
  Closed: "bg-stone-100 text-stone-600 border-stone-200",
  Rejected: "bg-red-50 text-red-700 border-red-200",
  Applied: "bg-blue-50 text-blue-700 border-blue-200",
  Shortlisted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Accepted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  Withdrawn: "bg-stone-100 text-stone-600 border-stone-200",
  Open: "bg-amber-50 text-amber-700 border-amber-200",
  Submitted: "bg-emerald-50 text-emerald-700 border-emerald-200",
  past_due: "bg-red-50 text-red-700 border-red-200",
  active: "bg-emerald-50 text-emerald-700 border-emerald-200",
  inactive: "bg-stone-100 text-stone-600 border-stone-200",
  cancelled: "bg-red-50 text-red-700 border-red-200",
};

export const StatusBadge = ({ status, testId }) => (
  <span data-testid={testId} className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-[11px] font-mono uppercase tracking-wider ${STATUS_STYLES[status] || "bg-stone-100 text-stone-600 border-stone-200"}`}>
    {status}
  </span>
);

export const CandidateAvatar = ({ candidate, className = "h-12 w-12" }) => {
  const [err, setErr] = useState(false);
  const src = photoSrc(candidate);
  const initials = (candidate?.name || "?").split(" ").map((p) => p[0]).slice(0, 2).join("");
  if (!src || err)
    return <div className={`${className} grid place-items-center rounded-md bg-stone-200 font-display font-bold text-stone-600`}>{initials}</div>;
  return <img src={src} alt={candidate?.name} onError={() => setErr(true)} className={`${className} rounded-md object-cover`} />;
};

export const PageHeader = ({ eyebrow, title, desc, children }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between rise">
    <div>
      {eyebrow && <p className="text-xs font-mono uppercase tracking-[0.18em] text-amber-700">{eyebrow}</p>}
      <h1 className="mt-2 font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-stone-900" data-testid="page-title">{title}</h1>
      {desc && <p className="mt-2 max-w-2xl text-sm sm:text-base text-stone-600">{desc}</p>}
    </div>
    {children && <div className="flex gap-2">{children}</div>}
  </div>
);

export const EmptyState = ({ icon: Icon, title, desc, children, testId }) => (
  <div data-testid={testId} className="rounded-md border border-dashed border-stone-300 bg-white px-6 py-16 text-center">
    {Icon && <Icon className="mx-auto h-8 w-8 text-stone-400" strokeWidth={1.5} />}
    <p className="mt-4 font-display text-lg font-bold text-stone-900">{title}</p>
    {desc && <p className="mt-1 text-sm text-stone-500">{desc}</p>}
    {children && <div className="mt-6">{children}</div>}
  </div>
);
